import formName from 'constants/formName'
import { UserType } from 'data/Auth/types'
import { ProfileFormType, StateType } from 'data/types'
import { getFormValues } from 'redux-form'
import { createSelector } from 'reselect'

import auth from '../../Auth/selectors'

const isAffiliate = (user) =>
  user.tags && user.tags.AFFILIATE && user.tags.AFFILIATE.MERCURY_AFFILIATE_USER_ENABLED === true

const getInitialValues: (state: StateType) => ProfileFormType = createSelector(
  auth.getUser,
  (user: UserType | undefined) => ({
    email: user?.email ?? '',
    firstname: user?.firstName ?? '',
    isAffiliate: user ? isAffiliate(user) === true : false,
    lastname: user?.lastName ?? '',
    username: user?.userName ?? ''
  })
)

const getValues = (state: StateType): ProfileFormType => {
  return getFormValues(formName.PROFILE)(state) as ProfileFormType
}

export default {
  getInitialValues,
  getValues
}
